const cardLinks = (host) => {
    const cards = host.querySelectorAll('.card');
    if (cards.length) {
        cards.forEach(card => {
            let link = card.querySelector('.card_target');
            if (!link)
                return;
            card.style.cursor = 'pointer';
            card.addEventListener('click', (e) => {
                //e.preventDefault();
                // Ignore modified clicks (Ctrl, Cmd, Shift, Alt, middle button)
                if (e.defaultPrevented ||
                    e.button !== 0 || // left click only
                    e.metaKey ||
                    e.ctrlKey ||
                    e.shiftKey ||
                    e.altKey) {
                    return; // Let browser handle new tab / new window
                }
                if (e.target.classList.contains('alt_trigger') || e.target.closest('.alt_block'))
                    return;
                if (e.target.tagName == 'ALLIN-ALT_BLOCK' || e.target.closest('allin-alt-block'))
                    return;
                if (e.target.tagName === 'A') {
                    if (e.target.classList.contains('follow')) {
                        window.location.href = e.target.href;
                    }
                    return;
                }
                ;
                e.preventDefault();
                link.click();
            });
        });
    }
};
export { cardLinks };
